<template>
	<Component
		:is="as"
		class="
			group
			btn btn-secondary pr-4 pl-2 text-body-s sm:text-body-m
			transition-all duration-500
		"
		:class="[active ? 'font-bold border-border-active': 'font-normal', sticky ? 'py-[.3125rem] gap-1 text-sm' : 'py-[.3125rem] sm:py-2.5 sm:min-h-12']"
		:aria-selected="active"
	>
		<span class="inline-flex w-4">
			<NuxtIcon v-if="isMounted && active" name="check" class="text-icon-primary group-active:text-icon-active" filled />
			<NuxtIcon v-else name="bullet" class="text-icon-tertiary group-hover:text-icon-neutral group-active:text-icon-active" filled />
		</span>
		<span class="text-body-primary group-active:text-body-primary group-aria-selected:font-bold">
			<slot />
		</span>
	</Component>
</template>

<script setup lang="ts">
	type Props = {
		as?: any;
		active?: boolean;
		sticky?: boolean;
	};

	withDefaults(defineProps<Props>(), {
		as: 'button',
		active: false,
	});

	const isMounted = useMounted();
</script>
